import React from "react";
import { Link, Warning } from "@phosphor-icons/react";

export default function ContinuityChainPanel({ shots }) {
  const roots = shots.filter((s) => (s.first_appearance_of || []).length > 0);
  const overflow = shots.filter((s) => s.ref_cap_exceeded);
  if (roots.length === 0 && overflow.length === 0) return null;

  const shotCode = (s) => `S${String(s.scene_number).padStart(2, "0")}_SH${String(s.shot_number).padStart(2, "0")}`;

  return (
    <div data-testid="continuity-chain-panel" className="border border-amber-500/20 bg-amber-500/5 rounded-sm p-3 space-y-3">
      <div className="flex items-center gap-2">
        <Link size={14} className="text-amber-400" />
        <h3 className="font-heading uppercase tracking-wider text-xs font-semibold text-amber-400">Continuity Chain</h3>
      </div>
      {roots.length > 0 && (
        <div className="space-y-1">
          <p className="text-[10px] text-slate-500 uppercase tracking-wider">Dependency roots (first appearance)</p>
          {roots.map((s) => (
            <div key={s.id} data-testid={`continuity-root-${s.id}`} className="text-xs text-slate-300 flex items-center gap-2 flex-wrap">
              <span className="font-mono text-slate-500">{shotCode(s)}</span>
              {s.first_appearance_of.map((e) => (
                <span key={`${e.tier}-${e.name}`} className="font-mono text-[10px] uppercase px-1.5 py-0.5 rounded-sm border text-amber-400 border-amber-500/30 bg-amber-500/10">
                  {e.tier}: {e.name}
                </span>
              ))}
              <span className="text-slate-600">— {s.gen_status}</span>
            </div>
          ))}
        </div>
      )}
      {overflow.length > 0 && (
        <div className="space-y-1">
          <p className="text-[10px] text-rose-400 uppercase tracking-wider flex items-center gap-1"><Warning size={10} /> Reference cap exceeded</p>
          {overflow.map((s) => (
            <div key={s.id} data-testid={`continuity-overflow-${s.id}`} className="text-xs text-slate-300 font-mono">
              {shotCode(s)} — {s.gen_status === "needs_ref_priority" ? "HOLDING for your priority pick" : "flagged, resolve priority before it reaches the front of the queue"}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
